import React from "react";
import styled from "styled-components";
import { DialogContent, Dialog, Grid } from "@mui/material";

import FormDisplay from "./FormDisplay";

const Card = styled(Dialog)`
  min-width: 360px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

export default function ChangeCampaignStatusDialog({
  formikProps,
  changeCampaignStatusDialog,
  setChangeCampaignStatusDialog,
}) {
  const handleClose = () => {
    setChangeCampaignStatusDialog(false);
  };

  return (
    <React.Fragment>
      <Card open={changeCampaignStatusDialog} onClose={handleClose}>
        <DialogContent>
          <Grid container spacing={3} style={{ padding: "20px" }}>
            <FormDisplay
              formikProps={formikProps}
              handleClose={handleClose}
              changeCampaignStatusDialog={changeCampaignStatusDialog}
            />
          </Grid>
        </DialogContent>
      </Card>
    </React.Fragment>
  );
}
